import type { FC } from "react";
import styles from "./LoginInfoBanner.module.scss";
import { LoginMessageContainer } from "./LoginMessageContainer";
import useTranslation from "next-translate/useTranslation";

const LoginInfoBanner: FC = () => {
  const { t } = useTranslation("web-payments");

  return (
    <div className={styles.container}>
      <div>
        <LoginMessageContainer
          messageTitle={t`BENEFIT_1`}
          messageContent={t`BENEFIT_1_BODY`}
          messageIconUrl="https://images.onefootball.com/cw/icons/star-shape-magenta.svg"
          messageIconDarkUrl="https://images.onefootball.com/cw/icons/star-shape-magenta-dark.svg"
          messageIconAlt={t`MY_INTEREST_EMPTY_ENTITY_SUBTITLE`}
        />

        <LoginMessageContainer
          messageTitle={t`BENEFIT_2`}
          messageContent={t`BENEFIT_2_BODY`}
          messageIconUrl="https://images.onefootball.com/cw/icons/tv-shape-magenta.svg"
          messageIconDarkUrl="https://images.onefootball.com/cw/icons/tv-shape-magenta-dark.svg"
          messageIconAlt="TV"
        />

        <LoginMessageContainer
          messageTitle={t`BENEFIT_3`}
          messageContent={t`BENEFIT_3_BODY`}
          messageIconUrl="https://images.onefootball.com/cw/icons/card-magenta.svg"
          messageIconDarkUrl="https://images.onefootball.com/cw/icons/card-magenta-dark.svg"
          messageIconAlt={t`CREDIT_CARD_METHOD`}
        />
      </div>
    </div>
  );
};

export { LoginInfoBanner };
